import { create } from "zustand";

const initialState = {
  filters: { search: "", ordering: "sort_index", tagsSelected: [] },
  pages: { pending: 1, started: 1, done: 1 },
  overview: { summary: "", goals: "", deadline: "" },
};

export const useTasksViewStore = create((set) => ({
  ...initialState,

  setSearch: (search) =>
    set((state) => ({
      filters: { ...state.filters, search: search || "" },
    })),

  setOrdering: (ordering) =>
    set((state) => ({
      filters: { ...state.filters, ordering: ordering || "sort_index" },
    })),

  setTagsSelected: (tags) =>
    set((state) => ({
      filters: {
        ...state.filters,
        tagsSelected: Array.isArray(tags) ? tags : [],
      },
    })),

  clearFilters: () =>
    set({ filters: { search: "", ordering: "sort_index", tagsSelected: [] } }),

  setPage: (column, page) =>
    set((state) => ({
      pages: { ...state.pages, [column]: page },
    })),

  resetPages: () =>
    set({ pages: { pending: 1, started: 1, done: 1 } }),

  setOverview: (next) =>
    set((_state) => ({
      overview: {
        summary: next?.summary || "",
        goals: next?.goals || "",
        deadline: next?.deadline || "",
      },
    })),

  reset: () => set(initialState),
}));
